import { GridColDef } from '@mui/x-data-grid';

import { InvoiceSortColumns } from 'openapi';

import { ACTIONS, COLUMNS_DEFAULT_OPTIONS } from 'utils/constants/constants';
import { TranslateFunction } from 'utils/interfaces/Translations';

import { sortDates } from './dates';
import { formatMoney } from './moneyHelper';

const formatOptionalValue = (value: any) => value || '-';

const formatAmount = (value: any, currency?: string) =>
  value ? `${formatMoney(value)} ${currency || 'EUR'}` : '-';

export const getRevenueColumns = (
  isInAllCompanies: boolean,
  translate: TranslateFunction
): GridColDef[] => {
  const columns: GridColDef[] = [
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: InvoiceSortColumns.STAGE,
      headerName: translate('labels.stage'),
      minWidth: 110,
      maxWidth: 110,
      headerAlign: 'center',
      align: 'center',
      resizable: false
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: InvoiceSortColumns.SHORT_COMPANY_NAME,
      headerName: translate('labels.shortCompanyName'),
      minWidth: 100,
      maxWidth: 130,
      headerAlign: 'left',
      align: 'left',
      resizable: false
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: InvoiceSortColumns.COUNTERPARTY_NAME,
      headerName: translate('labels.counterparty'),
      minWidth: 275,
      headerAlign: 'left',
      align: 'left',
      resizable: false
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: InvoiceSortColumns.INVOICE_NUMBER,
      headerName: translate('labels.number'),
      headerAlign: 'left',
      align: 'left',
      minWidth: 120,
      maxWidth: 180,
      resizable: false
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: InvoiceSortColumns.INVOICE_DATE,
      headerName: translate('labels.date'),
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      maxWidth: 100,
      sortComparator: sortDates,
      resizable: false
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: InvoiceSortColumns.INVOICE_AMOUNT,
      headerName: translate('labels.amount'),
      minWidth: 130,
      maxWidth: 140,
      headerAlign: 'right',
      align: 'right',
      resizable: false
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: InvoiceSortColumns.INSERTED_BY,
      headerName: translate('labels.insertedBy'),
      minWidth: 120,
      maxWidth: 200,
      align: 'left',
      headerAlign: 'left',
      resizable: false
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: InvoiceSortColumns.INSERTED_AT,
      headerName: translate('labels.insertedAt'),
      minWidth: 90,
      maxWidth: 120,
      headerAlign: 'left',
      align: 'left',
      valueFormatter: formatOptionalValue,
      resizable: false
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: ACTIONS,
      headerName: '',
      minWidth: 40,
      maxWidth: 110,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      resizable: false
    }
  ];
  return isInAllCompanies ? columns : [columns[0], ...columns.slice(2)];
};

export const getDashboardRevenueColumns = (
  isOnAllCompanies: boolean,
  translate: TranslateFunction,
  currency?: string
): GridColDef[] => {
  const allCompanyColumns = [
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'company',
      headerName: translate('labels.shortCompanyName'),
      align: 'left',
      headerAlign: 'left',
      sortable: false,
      flex: 0.33,
      valueFormatter: formatOptionalValue
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'documentNumber',
      headerName: translate('labels.number'),
      align: 'left',
      headerAlign: 'left',
      sortable: false,
      flex: 0.33,
      valueFormatter: formatOptionalValue
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'date',
      headerName: translate('labels.date'),
      align: 'left',
      headerAlign: 'left',
      sortable: false,
      flex: 0.3,
      valueFormatter: formatOptionalValue
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'counterparty',
      headerName: translate('labels.counterparty'),
      align: 'left',
      headerAlign: 'left',
      flex: 0.2,
      sortable: false,
      valueFormatter: formatOptionalValue
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'amount',
      headerName: translate('labels.amount'),
      align: 'left',
      headerAlign: 'left',
      flex: 0.2,
      sortable: false,
      valueFormatter: (value: any) => formatAmount(value, currency)
    }
  ] as GridColDef[];

  const columns = [
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'documentNumber',
      headerName: translate('labels.number'),
      align: 'left',
      headerAlign: 'left',
      sortable: false,
      flex: 0.33,
      valueFormatter: formatOptionalValue
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'date',
      headerName: translate('labels.date'),
      align: 'left',
      headerAlign: 'left',
      sortable: false,
      flex: 0.3,
      valueFormatter: formatOptionalValue
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'counterparty',
      headerName: translate('labels.counterparty'),
      align: 'left',
      headerAlign: 'left',
      flex: 0.2,
      sortable: false,
      valueFormatter: formatOptionalValue
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'amount',
      headerName: translate('labels.amount'),
      align: 'left',
      headerAlign: 'left',
      flex: 0.2,
      sortable: false,
      valueFormatter: (value: any) => formatAmount(value, currency)
    }
  ] as GridColDef[];

  return isOnAllCompanies ? allCompanyColumns : columns;
};
